import { baseThunk } from '../../fetch/basicThunk';
import { QUERY_GET_FACTORY_ITV_BOND_INFO } from '../../fetch/constantQueries';

export const getFactoryITVBond = baseThunk(`factoryITVBond/getInfo`, QUERY_GET_FACTORY_ITV_BOND_INFO, "GET")